import { render, staticRenderFns } from "./TheFlicking.vue?vue&type=template&id=3c23eb3d&scoped=true&lang=pug"
import script from "./TheFlicking.vue?vue&type=script&lang=js"
export * from "./TheFlicking.vue?vue&type=script&lang=js"
import style0 from "./TheFlicking.vue?vue&type=style&index=0&id=3c23eb3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c23eb3d",
  null
  
)

export default component.exports